var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52295 12.4995C2.52295 15.1517 3.57652 17.6952 5.45188 19.5706C7.32725 21.4459 9.87078 22.4995 12.5229 22.4995C15.1751 22.4995 17.7187 21.4459 19.594 19.5706C21.4694 17.6952 22.5229 15.1517 22.5229 12.4995C22.5229 9.84735 21.4694 7.30381 19.594 5.42844C17.7187 3.55308 15.1751 2.49951 12.5229 2.49951C9.87078 2.49951 7.32725 3.55308 5.45188 5.42844C3.57652 7.30381 2.52295 9.84735 2.52295 12.4995Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5229 12.4995H12.5229M12.5229 12.4995H9.52295M12.5229 12.4995V9.49951M12.5229 12.4995V15.4995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCircle);
export default __webpack_public_path__ + "static/media/icon-add-circle.e65b7620ae18c43d4fb491728ad7f2e6.svg";
export { ForwardRef as ReactComponent };